(function () {
  const normalize = (str) =>
    (str || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "");

  function getPersonalizacaoRadios() {
    const radios = document.querySelectorAll(
      "variant-picker input[type='radio']"
    );

    return [...radios].filter((r) =>
      normalize(r.name).includes("personalizacao")
    );
  }

  function updateVisibility() {
    const wrapper = document.getElementById("personalizacao-wrapper");
    if (!wrapper) return;

    const radios = getPersonalizacaoRadios();

    if (!radios.length) {
      wrapper.classList.add("forced-hide");
      clearInputs();
      return;
    }

    const checked = radios.find((r) => r.checked);
    if (!checked || normalize(checked.value) !== "sim") {
      wrapper.classList.add("forced-hide");
      clearInputs();
      return;
    }

    wrapper.classList.remove("forced-hide");
  }

  function clearInputs() {
    document
      .querySelectorAll("[data-personalizacao-input]")
      .forEach((input) => {
        input.value = "";
      });
  }

  document.addEventListener("change", updateVisibility);
  document.addEventListener("DOMContentLoaded", updateVisibility);

  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.querySelector('input[name="id"]')) return;

      form
        .querySelectorAll('input[name^="properties["]')
        .forEach((el) => {
          if (el.dataset.personalizacaoHidden) el.remove();
        });

      const radios = getPersonalizacaoRadios();
      const checked = radios.find((r) => r.checked);
      if (!checked || normalize(checked.value) !== "sim") return;

      document
        .querySelectorAll("[data-personalizacao-input]")
        .forEach((input) => {
          const value = input.value.trim();
          const propertyName = input.dataset.propertyName;

          if (!value || !propertyName) return;

          const hidden = document.createElement("input");
          hidden.type = "hidden";
          hidden.name = `properties[${propertyName}]`;
          hidden.value = value;
          hidden.dataset.personalizacaoHidden = "true";

          form.appendChild(hidden);
        });
    },
    true
  );
})();
